import {
    ActionButton,
    OfficeButton,
    OfficeHeader,
    TableComponent,
} from "components";
import { useNavigate, useSearch } from "react-location";
import { useUrlState, wrapClick } from "utils";

import CreateUserRoleContainer from "./create";
import { LocationGenerics } from "router/location";
import { PlusIcon } from "@heroicons/react/24/outline";
import UpdateUserRoleContainer from "./update";
import { UserCog2Icon } from "lucide-react";
import ViewRoleContainer from "./view";
import { useRoles } from "hooks/data/use-roles";

type Props = {};

const SettingsPage = (props: Props) => {
    const [modal, setModal] = useUrlState("modal");
    const { roles, loading, refetch } = useRoles();
    const searchParams = useSearch<LocationGenerics>();
    const navigate = useNavigate<LocationGenerics>();

    return (
        <>
            <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
                <OfficeHeader
                    renderActions={() => (
                        <OfficeButton
                            type="button"
                            onClick={wrapClick(() => {
                                setModal("create");
                            })}
                            size="sm">
                            <PlusIcon
                                className="-ml-0.5 mr-2 h-4 w-4"
                                aria-hidden="true"
                            />
                            Create User Role
                        </OfficeButton>
                    )}
                />
                <div className="flex flex-1 overflow-y-auto">
                    <div className="flex-1 mx-auto  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                        <TableComponent
                            title={"User Roles"}
                            loading={loading}
                            hasSearch
                            data={roles}
                            columns={[
                                {
                                    accessor: "position",
                                    name: "position",
                                },
                                {
                                    accessor: "actions",
                                    name: "actions",
                                    render: (item) => (
                                        <div className="flex justify-start items-center gap-2">
                                            <ActionButton
                                                action="view"
                                                onClick={() => {
                                                    navigate({
                                                        search(prev) {
                                                            return {
                                                                ...prev,
                                                                id: item?.user_role_id as string,
                                                                modal: "view",
                                                            };
                                                        },
                                                    });
                                                }}
                                            />
                                            <ActionButton
                                                action="update"
                                                onClick={() => {
                                                    navigate({
                                                        search(prev) {
                                                            return {
                                                                ...prev,
                                                                id: item?.user_role_id as string,
                                                                modal: "update",
                                                            };
                                                        },
                                                    });
                                                }}
                                            />
                                        </div>
                                    ),
                                },
                            ]}
                            refetch={refetch}
                            defaultView="grid"
                            renderGridItem={({ item }) => (
                                <div className="p-5 bg-card-500 border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-transform transform hover:-translate-y-1 flex flex-col justify-center items-center gap-4">
                                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
                                        <UserCog2Icon className="h-6 w-6 text-primary" />
                                    </div>

                                    <h3 className="text-sm font-semibold text-primary">
                                        {item?.position}
                                    </h3>

                                    {/* {item?.description && (
                                        <p className="text-xs text-gray-500 text-center">
                                            {item.description}
                                        </p>
                                    )} */}

                                    <div className="w-full flex justify-center items-center gap-3 mt-2">
                                        <ActionButton
                                            action="view"
                                            onClick={() => {
                                                navigate({
                                                    search(prev) {
                                                        return {
                                                            ...prev,
                                                            id: item?.user_role_id as string,
                                                            modal: "view",
                                                        };
                                                    },
                                                });
                                            }}
                                        />
                                        <ActionButton
                                            action="update"
                                            onClick={() => {
                                                navigate({
                                                    search(prev) {
                                                        return {
                                                            ...prev,
                                                            id: item?.user_role_id as string,
                                                            modal: "update",
                                                        };
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </div>
            </main>

            <CreateUserRoleContainer
                open={modal === "create"}
                setOpen={(val: boolean) => setModal(val ? "create" : undefined)}
                refetch={refetch}
            />

            {searchParams?.id && (
                <UpdateUserRoleContainer
                    open={modal === "update"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "update" : undefined)
                    }
                    refetch={refetch}
                />
            )}
            {searchParams?.id && (
                <ViewRoleContainer
                    open={modal === "view"}
                    setOpen={(val: boolean) =>
                        setModal(val ? "view" : undefined)
                    }
                />
            )}
        </>
    );
};

export default SettingsPage;
